import { UNIT, mainColor } from '../../constants/theme';

export const styles = () => ({
  progress: {
    margin: UNIT * 2,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    marginTop: UNIT * 1.25,
    marginBottom: UNIT * 1.25
  },
  body: {
    width: '100%',
    display: 'flex',
    padding: '10px 10px 0px 10px'
  },

  subtitle: { fontWeight: 'bold' },
  designText: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bold',
    paddingBottom: '5px'
  },

  paper: { marginTop: UNIT * 0.625, padding: '0px 0px 10px 5px', width: '100%' },
  paperStyle: {
    padding: UNIT * 0.625,
    width: '100%',
    borderRadius: '0px 0px 16px 0px!important'
  },

  root: {
    borderTop: `0.1px solid #eeeeee`,
    textAlign: 'center',
    margin: 'auto'
  },
  iconStyle: {
    marginBottom: UNIT * 0.8125
  },

  cover: {
    position: 'absolute',
    top: UNIT * 9.625,
    right: '0px',
    bottom: '0px',
    left: UNIT * 1.0625
  },
  iconColorStyle: {
    marginTop: UNIT * 0.375,
    marginLeft: -UNIT * 0.875,
    marginRight: -UNIT * 0.3125
  },

  persoIcon: {
    width: UNIT * 1.25,
    marginRight: UNIT * 0.4375,
    marginTop: UNIT,
    marginLeft: UNIT * 1.375
  },
  bottomNavig: {
    border: '1px solid #f2efef',
    height: `${UNIT * 13.5625}%`,
    borderRadius: UNIT * 0.375,
    marginTop: UNIT * 0.75,
    maxWidth: '100%',
  },
  inputStyle: {
    width: '100%',
    marginTop: UNIT * 0.625
  },
  personnalisationStyle: {
    height: UNIT * 3.5,
    backgroundColor: '#009973',
    borderColor: '#009973',
    color: 'white',
    borderTopRightRadius: UNIT
  },
  divStyle: {
    height: UNIT * 4.375
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: UNIT * 1.1875,
    letterSpacing: -UNIT * 0.0175,
    color: '#FFFFFF!important',
    marginTop: -UNIT * 1.3125,
    marginLeft: UNIT * 3.0625,
    lineHeight: 'initial'
  },
  structureDesign: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: -UNIT
  },
  buttonStyle: {
    width: '100%'
  },
  designTypeStyle: {
    textAlign: 'center',
    margin: 'auto'
  },
  marginStyle: {
    marginTop: -UNIT * 0.625
  },
  colorIcon: {
    marginLeft: UNIT * 1.125,
    marginRight: -UNIT * 2.5625
  },
  imageWidth: {
    width: UNIT * 1.625
  },
  iconSize: {
    fontSize: UNIT * 1.3125
  },
  designStyle: {
    width: 'fit-content',
    margin: 'auto'
  },
  checkOutStyle: {
    color: '#f2efef',
    fontSize: UNIT * 1.8125,
    marginTop: -UNIT * 0.1875
  }
});
